/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getComment: state => (id) => state.studentNoticeComments.find((comment) => comment.id == id),
  getStudentNotice: state => (id) => state.studentNotices.find((studentNotice) => studentNotice.id == id),
  // getStudentNotice: state => (id) => state.studentNotices.find((studentNotice) => studentNotice.id == id)
  filteredStudentNotice: state => state.studentNotices.filter((studentNotice) => {
    return (studentNotice.name.toLowerCase().includes(state.studentNoticeSearchQuery.toLowerCase()) || studentNotice.title.toLowerCase().includes(state.studentNoticeSearchQuery.toLowerCase()) ||
      studentNotice.update_time.toLowerCase().includes(state.studentNoticeSearchQuery.toLowerCase()) || studentNotice.detail.toLowerCase().includes(state.studentNoticeSearchQuery.toLowerCase()))
  }),
}
